import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea444be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "the-detailed-search",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "is-sr-only" }
const _hoisted_3 = { class: "the-detailed-search-body has-background-contents shadow" }
const _hoisted_4 = { class: "the-detailed-search-keyword level is-mobile" }
const _hoisted_5 = { class: "the-detailed-search-primary" }
const _hoisted_6 = { class: "the-detailed-search-queries" }
const _hoisted_7 = { class: "the-detailed-search-query level-left two-column" }
const _hoisted_8 = { class: "the-detailed-search-query-name" }
const _hoisted_9 = { class: "the-detailed-search-checkbox-list level-left is-mobile" }
const _hoisted_10 = { class: "the-detailed-search-query level-left" }
const _hoisted_11 = { class: "the-detailed-search-query-name" }
const _hoisted_12 = { for: "the-detailed-search-query-input-title" }
const _hoisted_13 = { class: "the-detailed-search-query level-left" }
const _hoisted_14 = { class: "the-detailed-search-query-name" }
const _hoisted_15 = { for: "the-detailed-search-query-input-creator" }
const _hoisted_16 = { class: "the-detailed-search-query the-detailed-search-query-publication-era level-left" }
const _hoisted_17 = { class: "the-detailed-search-query-name" }
const _hoisted_18 = { class: "the-detailed-search-query-value level-left is-mobile flex-wrap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "〜", -1))
const _hoisted_20 = { class: "the-detailed-search-query level-left" }
const _hoisted_21 = { class: "the-detailed-search-query-name" }
const _hoisted_22 = { for: "the-detailed-search-query-input-publisher" }
const _hoisted_23 = { class: "the-detailed-search-query level-left one-column" }
const _hoisted_24 = { class: "the-detailed-search-query-name" }
const _hoisted_25 = { class: "the-detailed-search-checkbox-list level-left is-mobile" }
const _hoisted_26 = { class: "the-detailed-search-queries" }
const _hoisted_27 = { class: "the-detailed-search-query level-left two-column" }
const _hoisted_28 = { class: "the-detailed-search-query-name" }
const _hoisted_29 = { class: "the-detailed-search-query-container" }
const _hoisted_30 = {
  key: 0,
  name: "NoCheckError"
}
const _hoisted_31 = { class: "the-detailed-search-query level-left one-column" }
const _hoisted_32 = { class: "the-detailed-search-query-name" }
const _hoisted_33 = { for: "the-detailed-search-query-input-publicationPlace" }
const _hoisted_34 = { class: "the-detailed-search-query level-left" }
const _hoisted_35 = { class: "the-detailed-search-query-name" }
const _hoisted_36 = { for: "the-detailed-search-query-input-tableOfContents" }
const _hoisted_37 = { class: "the-detailed-search-query level-left" }
const _hoisted_38 = { class: "the-detailed-search-query-name" }
const _hoisted_39 = { for: "the-detailed-search-query-input-subject" }
const _hoisted_40 = { class: "the-detailed-search-query the-detailed-search-query-identifier level-left" }
const _hoisted_41 = { class: "the-detailed-search-query-name" }
const _hoisted_42 = { class: "the-detailed-search-query-value level-left is-mobile" }
const _hoisted_43 = { class: "the-detailed-search-query level-left" }
const _hoisted_44 = { class: "the-detailed-search-query-name" }
const _hoisted_45 = { for: "the-detailed-search-query-input-callNumber" }
const _hoisted_46 = { class: "the-detailed-search-query level-left" }
const _hoisted_47 = { class: "the-detailed-search-query-name" }
const _hoisted_48 = { for: "the-detailed-search-query-input-ndc" }
const _hoisted_49 = { class: "the-detailed-search-query level-left" }
const _hoisted_50 = { class: "the-detailed-search-query-name" }
const _hoisted_51 = { for: "the-detailed-search-query-input-ndlc" }
const _hoisted_52 = { class: "the-detailed-search-secondary-footer level-right" }
const _hoisted_53 = { class: "the-detailed-search-primary-footer" }
const _hoisted_54 = { class: "the-detailed-search-show-modal is-hidden-desktop level-center is-mobile has-text-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_CheckboxList = _resolveComponent("CheckboxList")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_InputDate = _resolveComponent("InputDate")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_TextWithLeadingIcon = _resolveComponent("TextWithLeadingIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DetailedSearchFooter = _resolveComponent("DetailedSearchFooter")!
  const _component_ModalSheetMobile = _resolveComponent("ModalSheetMobile")!
  const _component_CloserController = _resolveComponent("CloserController")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('label.advancedSearch')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
        role: "search"
      }, [
        _createVNode(_component_ModalSheetMobile, {
          show: _ctx.state.showModal,
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.showModal = false)),
          title: _ctx.$t('label.specifySearchConditions'),
          id: "the-detailed-search-modal-sheet"
        }, {
          modal: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('form.accessRestrictions')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CheckboxList, {
                      items: _ctx.accessRestrictions,
                      modelValue: _ctx.query.accessRestrictions,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.accessRestrictions) = $event)),
                      id: "query-accessRestrictions"
                    }, null, 8, ["items", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('form.title')), 1)
                  ]),
                  _createVNode(_component_AppInput, {
                    modelValue: _ctx.query.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.title) = $event)),
                    "input-id": "the-detailed-search-query-input-title"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('form.creator')), 1)
                  ]),
                  _createVNode(_component_AppInput, {
                    modelValue: _ctx.query.creator,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.creator) = $event)),
                    "input-id": "the-detailed-search-query-input-creator"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('form.publicationDate')), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_AppSelect, {
                      modelValue: _ctx.query.eraType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.eraType) = $event)),
                      options: _ctx.eraListLocale,
                      "component-id": "publication-era",
                      "aria-label": _ctx.$t('label.yearOfPublication')
                    }, null, 8, ["modelValue", "options", "aria-label"]),
                    _createVNode(_component_InputDate, {
                      modelValue: _ctx.query.publicationFrom,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query.publicationFrom) = $event)),
                      lang: _ctx.lang,
                      key: _ctx.publicationResetKey,
                      "component-id": "publication-from",
                      label: _ctx.$t('form.afterPublicationYear'),
                      class: "flex-grow-firefox"
                    }, null, 8, ["modelValue", "lang", "label"]),
                    _hoisted_19,
                    _createVNode(_component_InputDate, {
                      modelValue: _ctx.query.publicationTo,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.publicationTo) = $event)),
                      lang: _ctx.lang,
                      key: _ctx.publicationResetKey,
                      "component-id": "publication-to",
                      label: _ctx.$t('form.beforePublicationYear'),
                      class: "flex-grow-firefox"
                    }, null, 8, ["modelValue", "lang", "label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('form.publisher')), 1)
                  ]),
                  _createVNode(_component_AppInput, {
                    modelValue: _ctx.query.publisher,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query.publisher) = $event)),
                    "input-id": "the-detailed-search-query-input-publisher"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('form.option')), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_AppCheckbox, {
                      modelValue: _ctx.query.fullText,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.query.fullText) = $event)),
                      value: true,
                      id: "query-fulltext"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('form.fulltext')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_AppCheckbox, {
                      modelValue: _ctx.query.includeVolumeNum,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.query.includeVolumeNum) = $event)),
                      value: false,
                      id: "query-except"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('form.includeVolumeNum')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                "aria-live": "polite",
                id: "detailed-search-queries",
                class: _normalizeClass(["the-detailed-search-secondary", { 'is-hidden-desktop': !_ctx.state.showAll }])
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('form.collection')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_CheckboxList, {
                        items: _ctx.collectionCheckboxItem[_ctx.lang],
                        modelValue: _ctx.query.collection,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.query.collection) = $event)),
                        hasButton: true,
                        id: "query-category-code",
                        class: "query-category-code"
                      }, null, 8, ["items", "modelValue"]),
                      (_ctx.hasErrorCollection)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_TextAlert, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('form.noCollectionMsg')), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('form.publicationPlace')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.publicationPlace,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.query.publicationPlace) = $event)),
                      "input-id": "the-detailed-search-query-input-publicationPlace"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('form.index')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.tableOfContents,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.query.tableOfContents) = $event)),
                      "input-id": "the-detailed-search-query-input-tableOfContents"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('form.subject')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.subject,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.query.subject) = $event)),
                      "input-id": "the-detailed-search-query-input-subject"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('form.identifier')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_AppSelect, {
                        modelValue: _ctx.query.identifierItem,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.query.identifierItem) = $event)),
                        options: _ctx.identifierListLocale,
                        componentId: "the-detailed-search-query-input-identifierItem"
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode(_component_AppInput, {
                        modelValue: _ctx.query.identifier,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.query.identifier) = $event)),
                        "input-id": "the-detailed-search-query-input-identifier",
                        class: "flex-grow",
                        label: _ctx.$t('form.identifier')
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('form.callNumber')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.callNumber,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.query.callNumber) = $event)),
                      "input-id": "the-detailed-search-query-input-callNumber"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('form.ndc')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.ndc,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.query.ndc) = $event)),
                      "input-id": "the-detailed-search-query-input-ndc"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('form.ndlc')), 1)
                    ]),
                    _createVNode(_component_AppInput, {
                      modelValue: _ctx.query.ndlc,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.query.ndlc) = $event)),
                      "input-id": "the-detailed-search-query-input-ndlc"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_router_link, {
                    to: '/help#idx2-2',
                    id: "to-detail-search-help",
                    class: "level is-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TextWithLeadingIcon, {
                        class: "has-text-modest",
                        icon: "circle-questionmark",
                        packing: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('parts.searchItem')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ], 2),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_DetailedSearchFooter, {
                  onClearButtonEvent: _ctx.clearForm,
                  modelValue: _ctx.state.showAll,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.showAll) = $event))
                }, null, 8, ["onClearButtonEvent", "modelValue"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AppInput, {
                modelValue: _ctx.query.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.keyword) = $event)),
                label: _ctx.$t('label.keyword'),
                placeholder: _ctx.$t('label.keyword'),
                "data-cy": "the-detailed-search-query-input-keyword"
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_ButtonIcon, {
                "data-cy": "the-detailed-search-keyword",
                styled: "is-accent",
                type: "submit",
                "aria-label": _ctx.$t('parts.search'),
                text: _ctx.$t('parts.search')
              }, null, 8, ["aria-label", "text"])
            ])
          ]),
          _: 1
        }, 8, ["show", "title"])
      ], 32),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_CloserController, {
          modelValue: _ctx.state.showModal,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.showModal) = $event)),
          text: _ctx.$t('label.addSearchCriteria'),
          "aria-controls": "the-detailed-search-modal-sheet"
        }, null, 8, ["modelValue", "text"])
      ])
    ])
  ]))
}